<template>
    <div v-if="error" class="alert alert-error">
        <template v-if="error.code == 'partner.invalid'">
            <b>Sorry, this attendee is no longer available</b>
        </template>
        <template v-else-if="error.code == 'meeting.invalid'">
            <b>Sorry, this meeting is no longer available</b>
        </template>
        <template v-else-if="error.code == 'appointment.invalid'">
            <b>Sorry, this session is no longer available</b>
        </template>
        <template v-else>
            <b>Chat error: Please contact your manager</b>
        </template>
        <div class="smallprint">
            Room: {{error.room}}
            <br>Code: {{error.code}} 
        </div>
    </div>
</template>
<script>

export const ERRORS = {
  APPOINTMENT_INVALID: 'appointment.invalid',
  MEETING_INVALID: 'meeting.invalid',
  MODERATOR_INVALID: 'moderator.invalid',
  PARTNER_INVALID: 'partner.invalid',
  ROOM_INVALID: 'room.invalid',
  ROOM_MISSING: 'room.missing',
};

export default {
    name: "ChatError",
    props: {
        error: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style>

</style>